import { createRouter, createWebHistory } from 'vue-router';
import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';
import ExternalRoutes from './ExternalRoutes';
import TransmittalRoutes from './TransmittalRoutes';
import { useAuthStore } from '@/stores/auth';

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/:pathMatch(.*)*',
            component: () => import('@/views/authentication/Error.vue')
        },
        {
            path: '/learn-more',
            component: () => import('@/views/Learnmore.vue')
        },
        {
            path: '/brochure',
            component: () => import('@/views/BrochureLogin.vue') 
        },
        {
            path: '/faqs',
            component: () => import('@/views/Faqs.vue')
        },

        MainRoutes,
        AuthRoutes,
        ExternalRoutes,
        TransmittalRoutes,
    ]
});

router.beforeEach(async (to, from, next) => {
    const publicPages = ['/auth/login', '/learn-more' , '/brochure' , '/faqs']; 
    const authRequired = !publicPages.includes(to.path);
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    // Check if route requires authentication
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token && authRequired) {
            return next('/auth/login');
        }

        // Check role-based authorization
        const allowedRoles: string[] = to.meta.roles || [];

        if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
            return next('/invalid-destination');
        }
    }

    return next();
});